module.exports = __webpack_public_path__ + "static/assets/331022443472d945e1ca25c4b2b63f33.svg";